<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>
    <h2 langkey="phResetBasketWarning_Title"></h2>
    <div>
      <p class="invalidDeliveryAddress_content">{{setSubHeaderContent()}}</p>
    </div>
    <div>
      <p class="invalidDeliveryAddress_content" langkey="phResetBasketWarning_Content"></p>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button mat-flat-button (click)="resetBasket()">
              <span langkey="phResetBasketWarning_ResetBasket_Button"></span>
            </button>
          </div>
          <div class="ya-button-container">
            <button mat-stroked-button (click)="cancelChangeBasket()">
              <span langkey="phResetBasketWarning_RemainOrder_Button"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>